import React from 'react';
import PropTypes from 'prop-types';
import BoostrapPagination from 'react-bootstrap/lib/Pagination';
import { FormattedMessage } from 'react-intl';
import { createUltimatePagination, ITEM_TYPES } from 'react-ultimate-pagination';

const Pagination = createUltimatePagination({
  WrapperComponent: BoostrapPagination,
  itemTypeToComponent: {
    [ITEM_TYPES.PAGE]: ({ value, isActive, onClick }) => (
      <BoostrapPagination.Item active={isActive} onClick={onClick}>{value}</BoostrapPagination.Item>
    ),
    [ITEM_TYPES.ELLIPSIS]: ({ isActive, onClick }) => (
      <BoostrapPagination.Ellipsis disabled={isActive} onClick={onClick} />
    ),
    [ITEM_TYPES.FIRST_PAGE_LINK]: ({ isActive, onClick }) => (
      <BoostrapPagination.First disabled={isActive} onClick={onClick} />
    ),
    [ITEM_TYPES.PREVIOUS_PAGE_LINK]: ({ onClick, isActive }) => (
      <BoostrapPagination.Prev disabled={isActive} onClick={onClick} />
    ),
    [ITEM_TYPES.NEXT_PAGE_LINK]: ({ onClick, isActive }) => (
      <BoostrapPagination.Next disabled={isActive} onClick={onClick} />
    ),
    [ITEM_TYPES.LAST_PAGE_LINK]: ({ isActive, onClick }) => (
      <BoostrapPagination.Last disabled={isActive} onClick={onClick} />
    )
  }
});

export const PaginationRange = ({ limit, currentPage, pageCount, totalCount, suffix }) => {
  const parsePage = parseInt(currentPage, 10);
  const parsePageCount = parseInt(pageCount, 10);
  const parseTotalCount = parseInt(totalCount, 10);
  const from = ((limit * parsePage) - limit) + 1;
  const to = from + limit - 1;
  return (
    <div className="ellipsis">
      <FormattedMessage
        id="hosting.pagination_button.showing_text"
        defaultMessage="Showing {from}-{to} of {parseTotalCount} {suffix}"
        values={{
          from: 0 < parseTotalCount ? from : 0,
          to: Math.min(to, parseTotalCount),
          parseTotalCount,
          suffix: suffix || ''
        }}
      />
    </div>
  );
};
export class PaginationBtn extends React.Component {
  constructor (props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect (pageNumber) {
    this.props.paginate({ eventKey: pageNumber });
  }

  render () {
    const { page, first, last, limit, totalCount, pageCount } = this.props;
    const parsePage = parseInt(page, 10) || 1;
    const parseTotalCount = parseInt(totalCount, 10);
    const items = 0 === parseTotalCount % limit ? (parseTotalCount / limit) : Math.ceil((parseTotalCount + 1) / limit);
    return (
      <div className="pagination-container">
        <ul className="list-inline">
          <li className="hidden-xs v-center page-text text-gray-600">
            <PaginationRange
              limit={limit}
              currentPage={page}
              pageCount={pageCount}
              totalCount={totalCount}
            />
          </li>
          <li className="v-center text-center page-btn">
            <Pagination
              currentPage={parsePage}
              totalPages={items}
              onChange={this.handleSelect}
              boundaryPagesRange={0}
              hideFirstAndLastPageLinks={!first || !last}
            />
          </li>
        </ul>
      </div>
    );
  }
}

PaginationBtn.propTypes = {
  maxButtons: PropTypes.number,
  paginate: PropTypes.func,
  first: PropTypes.bool,
  last: PropTypes.bool,
  page: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  limit: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  totalCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  pageCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};
